module.exports = __webpack_public_path__ + "static/media/smooth-arrow.b65773d3.svg";